import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-banner',
    templateUrl: './banner.component.html',
})
export class BannerComponent extends Block {

}
